/**
 * --------------------------------------------------------------------------
 * NJ : AbstractBaseSelection.js
 * --------------------------------------------------------------------------
 */

import { EventHandler, Manipulator, Testing } from 'nj-utils';
import AbstractFormBaseInput from './AbstractFormBaseInput';

/**
 * ------------------------------------------------------------------------
 * Constants
 * ------------------------------------------------------------------------
 */

const SELECTOR = {
  label: 'label'
};

const DEFAULT_CONFIG = {
  label: {
    required: false
  }
};

class AbstractFormBaseSelection extends AbstractFormBaseInput {
  constructor(Component, element, config, properties) {
    super(Component, element, Manipulator.extend(true, DEFAULT_CONFIG, config), properties);

    if (this.constructor === AbstractFormBaseSelection) {
      throw new TypeError('Abstract class "AbstractFormBaseSelection" cannot be instantiated directly');
    }

    this.decorateMarkup();
  }

  decorateMarkup() {
    const decorator = Manipulator.createHtmlNode(this.config.template);
    this.element.parentNode.appendChild(decorator);
  }

  // Demarcation element (e.g. first child of a form-group)
  outerElement() {
    return this.element.parentNode.closest(this.outerClass);
  }

  rejectWithoutRequiredStructure() {
    // '.checkbox|switch|radio > label > input[type=checkbox|radio]'
    // '.${this.outerClass} > label > input[type=${this.inputType}]'
    Testing.assert(
      this.element,
      !this.element.parentNode.tagName === 'label',
      `${this.constructor.name}'s ${Testing.describe(
        this.element
      )} parent element should be <label>.`
    );
    Testing.assert(
      this.element,
      !this.outerElement().classList.contains(this.outerClass),
      `${this.constructor.name}'s ${Testing.describe(
        this.element
      )} outer element should have class ${this.outerClass}.`
    );
  }

  addFocusListener() {
    // checkboxes didn't appear to bubble to the document, so we'll bind these directly
    const anscestor = this.element.closest(SELECTOR.label);
    EventHandler.on(anscestor, 'mouseenter', () => {
      this.addFormGroupFocus();
    });

    EventHandler.on(anscestor, 'mouseleave', () => {
      this.removeFormGroupFocus();
    });
  }

  addChangeListener() {
    EventHandler.on(this.element, 'change', () => {
      this.element.blur();
    });
  }
}

export default AbstractFormBaseSelection;
